// extracted by mini-css-extract-plugin
export var discard = "_42-3";
export var muiTooltipTooltip = "_42-5";
export var notificationBar = "_42-2";
export var saveButtonHoverSlotWrapper = "_42-4";
export var show = "_42-1";
export var spacer = "_42-0";